/* Product-level availability and opt-in Instagram. No ad pixels or tracking calls. */
(() => {
  'use strict';
  const normalise = value => String(value || '').trim().toUpperCase().replace(/^2XL$/, 'XXL').replace(/^3XL$/, 'XXXL');
  const pageForm = () => document.querySelector('.product-page [data-product-form] select[name="id"]');
  let bypassSize = false;
  function refineRecommendations(root) {
    if (!root) return;
    const select=pageForm();
    const size = bypassSize ? '' : normalise(select?.selectedOptions[0]?.dataset.size);
    const cards=[...root.querySelectorAll('[data-recommendation-candidate]')];
    let count=0;
    cards.forEach(card=>{
      let stock=[];try{stock=JSON.parse(card.querySelector('[data-candidate-stock]').textContent);}catch{}
      const variant=stock.find(v=>v.available && (!size || !v.size || normalise(v.size)===size));
      card.hidden=!variant || count>=4;
      if (card.hidden) return;
      count++;
      card.querySelectorAll('a[href]').forEach(link=>{
        if (!link.dataset.originalUrl) link.dataset.originalUrl=link.getAttribute('href');
        const url=new URL(link.dataset.originalUrl,location.origin);
        if(size)url.searchParams.set('variant',variant.id);
        link.href=url.href;if(link.hasAttribute('data-quick'))link.dataset.quick=url.href;
      });
      const price=card.querySelector('.card-price');
      if(price){if(!price.dataset.original)price.dataset.original=price.innerHTML;
        if(size){price.replaceChildren(document.createTextNode(variant.price));if(variant.compare){const old=document.createElement('s');old.textContent=variant.compare;price.append(' ',old);}}
        else price.innerHTML=price.dataset.original;
      }
      const badge=card.querySelector('.sale-badge');if(badge)badge.hidden=!!size;
      const note=card.querySelector('[data-recommendation-size]');
      if(note){note.hidden=!size || !variant.size;note.textContent=size;}
    });
    const status=root.querySelector('[data-recommendation-status]');
    if(status)status.textContent=size?(count?root.dataset.sizeNote.replace('[size]',size):root.dataset.sizeEmpty):'';
    const reset=root.querySelector('[data-recommendation-reset]');
    if(reset){reset.hidden=!size;reset.onclick=()=>{bypassSize=true;refineRecommendations(root);};}
  }
  function refresh(){document.querySelectorAll('[data-recommendations]').forEach(refineRecommendations);}
  document.addEventListener('change',event=>{if(event.target.closest('.product-page [data-product-form]')){bypassSize=false;refresh();}});
  document.querySelectorAll('[data-recommendations]').forEach(root=>{
    // Shopify replaces this root after fetching native recommendations.
    const observer=new MutationObserver(refresh);observer.observe(root.parentElement,{childList:true});
  });
  refresh();
  const dialog=document.querySelector('[data-story-dialog]');
  if(!dialog)return;
  let trigger=null;
  document.querySelectorAll('[data-product-story]').forEach(link=>link.addEventListener('click',event=>{
    if(typeof dialog.showModal!=='function')return;
    event.preventDefault();trigger=link;dialog.showModal();
  }));
  dialog.querySelector('[data-story-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  dialog.querySelector('[data-story-load]').addEventListener('click',()=>{
    const host=dialog.querySelector('[data-story-frame]');if(host.firstChild)return;
    const url=new URL(trigger.dataset.storyUrl);
    if(url.origin!=='https://www.instagram.com' || !/^\/(p|reel)\/[A-Za-z0-9_-]+\/$/.test(url.pathname))return;
    const frame=document.createElement('iframe');frame.title=dialog.querySelector('h2').textContent;
    frame.src=url.origin+url.pathname+'embed/';frame.allow='fullscreen';frame.referrerPolicy='no-referrer';
    host.append(frame);dialog.querySelector('[data-story-consent]').hidden=true;
  });
  dialog.addEventListener('close',()=>{dialog.querySelector('[data-story-frame]').replaceChildren();dialog.querySelector('[data-story-consent]').hidden=false;trigger?.focus({preventScroll:true});});
})();
